// extracted by mini-css-extract-plugin
module.exports = {"drawer_menu":"drawerMenu_drawer_menu__12Mxu","logo":"drawerMenu_logo__2mkwH","header":"drawerMenu_header__1n5RD","navi":"drawerMenu_navi__3TSKj"};